
import React from "react";
import { PageContainer } from "@/components/ui/page-container";
import { Check } from "lucide-react";

const Donation = () => {
  return (
    <PageContainer
      title="Faites un don pour soutenir Médicace"
      variant="default"
    >
      <div className="container mx-auto py-10">
        <div className="text-center max-w-3xl mx-auto mb-10">
          <h2 className="text-3xl font-bold tracking-tight mb-4">Soutenez notre mission de santé</h2>
          <p className="text-muted-foreground">
            Votre soutien financier nous aide à améliorer nos services, à atteindre plus de communautés haïtiennes, et à offrir des ressources médicales accessibles à tous.
          </p>
        </div>

        <iframe 
          id='kofiframe' 
          src='https://ko-fi.com/medica_ace/?hidefeed=true&widget=true&embed=true&preview=true' 
          style={{border: 'none', width: '100%', padding: '4px', background: '#f9f9f9'}} 
          height='712' 
          title='medica_ace'
        />
        
        <div className="bg-muted p-6 rounded-lg">
          <h3 className="text-xl font-semibold mb-4">À quoi servent vos dons</h3>
          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4 text-sm">
            <div className="flex items-start gap-3">
              <div className="bg-primary/10 p-2 rounded-full">
                <Check className="h-5 w-5 text-primary" />
              </div>
              <div>
                <h4 className="font-medium">Amélioration technologique</h4>
                <p className="text-muted-foreground">Développement de nouvelles fonctionnalités et maintenance</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="bg-primary/10 p-2 rounded-full">
                <Check className="h-5 w-5 text-primary" />
              </div>
              <div>
                <h4 className="font-medium">Contenus médicaux</h4>
                <p className="text-muted-foreground">Création de ressources éducatives vérifiées</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="bg-primary/10 p-2 rounded-full">
                <Check className="h-5 w-5 text-primary" />
              </div>
              <div>
                <h4 className="font-medium">Programmes d'accès</h4>
                <p className="text-muted-foreground">Rendre nos services disponibles dans les zones reculées</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageContainer>
  );
};

export default Donation;
